export default __webpack_public_path__ + "static/media/main-icon.6f9b6c16.svg";